export default {
    unknown: 0,
    loggedIn: 1,
    notLoggedIn: 2
}